<script lang="ts">
  import Input from '$shared/atoms/Input/Input.svelte';
  import { InputType } from '$shared/constants/InputType';
  import Radio from '$shared/atoms/Radio/Radio.svelte';
  import MonitorTriggerType, {
    getMonitorTriggerOptionAsList
  } from '$provider/constants/MonitorTriggerType';
  import { onMount } from 'svelte';

  interface Props {
    name?: string;
    isNewVerification?: boolean;
    onchange?: (data: { monitoringDate: string; active: string }) => void;
  }

  let { name = 'monitor-option', isNewVerification = false, onchange }: Props = $props();

  let active: string = $state(MonitorTriggerType.Later);
  let list: CommonList[] = $state([]);
  let monitoringDate: string = $state('');

  onMount(() => {
    list = getMonitorTriggerOptionAsList();
    // If verification for this monitor is new, then set it to immediate
    if (isNewVerification) {
      active = MonitorTriggerType.Immediate;
    }
    dispatchChange();
  });

  const dispatchChange = (): void => {
    const data = {
      monitoringDate,
      active
    };
    onchange?.(data);
  };

  const onDateChange = (e: { value: string }): void => {
    monitoringDate = e.value?.trim() || '';
    dispatchChange();
  };

  const onRadioChange = (item: CommonList): void => {
    active = item.id;
    monitoringDate = '';
    dispatchChange();
  };

  export const resetDate = (): void => {
    monitoringDate = '';
  };

  export const setDate = (data: string): void => {
    monitoringDate = data;
  };
</script>

<div class="comp-monitor-option">
  <div data-cy="monitor-option-title" class="title">Start next monitoring verification...</div>

  <div class="option">
    {#each list as item}
      <div class="radio-item">
        <Radio {name} {item} active={active === item.id} onchange={() => onRadioChange(item)}>
          {#if item.id === MonitorTriggerType.Later}
            <div class="input-value">
              <Input
                name={`${name}-i`}
                type={InputType.Date}
                readonly={active === MonitorTriggerType.Immediate}
                value={monitoringDate}
                oninput={onDateChange}
              />
            </div>
          {/if}
        </Radio>
      </div>
    {/each}
  </div>
</div>

<style>
  .comp-monitor-option {
    background-color: var(--yellow-light);
    box-shadow: 1px 10px 15px -10px rgb(0 0 0 / 10%);
    border-radius: 5px;
  }
  .title {
    color: var(--yellow-dark);
    text-align: center;
    padding: 10px;
  }
  .option {
    padding: 7px 16px 16px;
  }
  .radio-item:not(:last-child) {
    margin-bottom: 8px;
  }
  .input-value {
    margin-left: 10px;
  }
</style>
